import { Intro, DataTable, PopOverMenu } from 'components/commons';
import { useApi, useFilter, useMount } from 'hooks';
import useModal from 'hooks/useModal';
import React, { useCallback, useMemo } from 'react';
import { productColumns } from './product-columns';
import { productFilterState } from './product-filter.state';
import styles from './product.module.scss';
import locale from 'localization';
import VehicleFilter from './product-filter';
import UsersForm from './product-form';
import { getProducts } from 'apis/product.api';

const ProductModule = () => {
  const { modifyFilter, modifyFilters, filterState, requestState, submitFilter } = useFilter(productFilterState());
  const userFormModal = useModal();

  const {
    request: getProductsRequest,
    loading: fetchingProducts,
    result: getProductsResult = { products: [], count: 0 }
  } = useApi({
    api: getProducts,
    pageError: true
  });

  useMount(() => {
    fetchUsers(requestState);
  });

  const fetchUsers = useCallback(
    (rs) => {
      getProductsRequest(submitFilter({ ...rs }));
    },
    [getProductsRequest, submitFilter]
  );

  const preparedProductsData = useMemo(() => {
    const { products } = getProductsResult;
    if (products.length > 0) {
      const preparedData = products.map((d) => {
        const map = new Map();
        map.set('code', d.code);
        map.set('name', d.name);
        map.set('interest', d.interest || '--');
        map.set('terms', d.terms || '--');

        let options = [];
        let editDetails;

        editDetails = {
          content: locale.editDetails,
          onClick: () => {
            userFormModal.show({
              title: locale.editDetails,
              actionText: locale.save,
              create: false,
              productId: d.productId,
              type: d.type,
              initialState: {
                name: {
                  value: d.name
                },
                code: {
                  value: d.code,
                  disabled: true
                },
                interest: {
                  value: d.interest
                },
                terms: {
                  value: d.terms
                },
                type: {
                  value: d.type
                }
              }
            });
          }
          // disabled: deactivated
        };
        options.push(editDetails);

        map.set('options', <PopOverMenu options={options} />);
        return map;
      });
      return preparedData;
    }
    return [];
  }, [getProductsResult, userFormModal]);

  const onSearchCb = useCallback(
    (searchKey) => {
      const { requestState } = modifyFilters({ searchKey, page: 1 });
      fetchUsers(requestState);
    },
    [fetchUsers, modifyFilters]
  );

  const onChangePageCb = useCallback(
    (page) => {
      const { requestState } = modifyFilters({ page });
      fetchUsers(requestState);
    },
    [fetchUsers, modifyFilters]
  );

  const onChangePageSizeCb = useCallback(
    (perPage) => {
      const { requestState } = modifyFilters({ perPage, page: 1 });
      fetchUsers(requestState);
    },
    [fetchUsers, modifyFilters]
  );

  return (
    <div>
      <UsersForm
        {...userFormModal}
        refreshPage={() => {
          getProductsRequest(requestState);
        }}
      />
      <div>
        <Intro
          title={'Products Management'}
          subtitle={'Manage your products and keep their information up to date.'}
          actionText={'Add Products'}
          actionOnClick={() => {
            userFormModal.show({
              title: 'Add Product',
              actionText: 'Add',
              create: true,
              initialState: {
                name: {
                  value: ''
                }
              }
            });
          }}
          // actionDisabled={}
        />
      </div>
      <div className={styles.filters}>
        <div>
          <VehicleFilter filterState={filterState} onSearchChange={modifyFilter} onSearch={onSearchCb} />
        </div>
      </div>
      <div className={styles.table}>
        <DataTable
          loading={fetchingProducts}
          page={filterState.page}
          pageSize={filterState.perPage}
          columns={productColumns}
          data={preparedProductsData}
          dataCount={getProductsResult.count}
          onChangePage={onChangePageCb}
          onChangePageSize={onChangePageSizeCb}
        />
      </div>
    </div>
  );
};

export default ProductModule;
